// Description of how to validate Norwegian organisasjonsnummer can be found here:
// https://www.brreg.no/om-oss/oppgavene-vare/alle-registrene-vare/om-enhetsregisteret/organisasjonsnummeret/

export const validateOrgnr = (orgnr: string) => {
  // Must be a number and have 9 digits
  if (orgnr.length !== 9) return false;
  if (Number.isNaN(Number(orgnr))) return false;

  const controlTarget = Number(orgnr.charAt(8));

  // Calculate control number and compare
  const weights = [3, 2, 7, 6, 5, 4, 3, 2];

  let sum = 0;
  for (let i = 0; i < 8; i++) {
    sum += Number(orgnr.charAt(i)) * weights[i];
  }

  const rest = sum % 11;
  const controlCalculated = rest === 0 ? 0 : 11 - rest;

  // Illegal control number
  if (controlCalculated === 10) return false;

  return controlCalculated === controlTarget;
};
